module.exports = __webpack_public_path__ + "img/adler500.b9441f05.png";